import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Article from './modules/Article.js'
import ArticleCreate from './modules/ArticleCreate.js'
import PermissionList from './modules/PermissionList.js'
import RoleList from './modules/RoleList.js'
import UserManage from './modules/UserManage.js'
import Layout from '../layout/index.vue'
import store from '@/store'

const Login = () => import('../views/login/index.vue')
export const pritiveRoutes = [Article, ArticleCreate, PermissionList, RoleList, UserManage]
export const publicRoutes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/profile',
    children: [
      {
        path: '/profile',
        name: 'profile',
        component: () =>
          import(/* webpackChunkName: "profile" */ '@/views/profile/index'),
        meta: {
          title: 'profile',
          icon: 'personnel'
        }
      },
      {
        path: '/chart',
        name: 'chart',
        component: () =>
          import(/* webpackChunkName: "chart" */ '@/views/chart/index'),
        meta: {
          title: 'chart',
          icon: 'chart'
        }
      },
      {
        path: '/404',
        name: '404',
        component: () =>
          import(/* webpackChunkName: "error-page" */ '@/views/error-page/404')
      },
      {
        path: '/401',
        name: '401',
        component: () =>
          import(/* webpackChunkName: "error-page" */ '@/views/error-page/401')
      }
    ]
  }
]
// 重置路由表
export function resetRouter() {
  if (
    store.getters.userInfo &&
    store.getters.userInfo.permission &&
    store.getters.userInfo.permission.menus
  ) {
    const menus = store.getters.userInfo.permission.menus
    menus.forEach((menu) => {
      router.removeRoute(menu)
    })
  }
}
const router = createRouter({
  history: process.env.NODE_ENV === 'production'
    ? createWebHistory()
    : createWebHashHistory(),
  routes: publicRoutes
})

export default router
